// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planoscontas_CreateTemplateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for create_template endpoint
 *
 * Returns the created plano record with nested itens and a message.
 *
 * @see Planoscontas_TemplateItemRow
 */
import type { Planoscontas_TemplateItemRow } from './Planoscontas_TemplateItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planoscontas_CreateTemplateResponseDados {
id: number
franquia_id: number
status: string
nome: string
created_at: string
updated_at: string
itens: Planoscontas_TemplateItemRow[]
message: string
}

export type Planoscontas_CreateTemplateResponse = ApiResponse<Planoscontas_CreateTemplateResponseDados>;

registerResponseContract('Planoscontas_CreateTemplateResponse', {
  id:          { type: 'number',  required: true },
  franquia_id: { type: 'number',  required: true },
  status:      { type: 'string',  required: true },
  nome:        { type: 'string',  required: false },
  created_at:  { type: 'string',  required: true },
  updated_at:  { type: 'string',  required: true },
  itens: {
    type: 'array',
    required: true,
    items: {
      id:                { type: 'number',  required: false },
      plano_id:          { type: 'number',  required: false },
      categoria_id:      { type: 'number',  required: false },
      tipo:              { type: 'string',  required: false },
      percentual_custom: { type: 'string',  required: false },
      valor_previsto:    { type: 'string',  required: false },
      created_at:        { type: 'string',  required: false },
      updated_at:        { type: 'string',  required: false },
      categoria_nome:    { type: 'string',  required: false },
    },
  },
  message:     { type: 'string',  required: true },
})
